export default "__VITE_ASSET__BqzMJD_r__"